import React from "react";
import { usePermissao } from "../../Hooks/usePermissao";

const AuthGuard = ({ tipoPermissao, IDPermissao, children }) => {
    const { possuiTipo, possuiIDPermissao } = usePermissao();

    const autorizado = tipoPermissao
        ? possuiTipo(tipoPermissao)
        : possuiIDPermissao(IDPermissao);

    if (!autorizado) return null;

    return <>{children}</>;
};

export default AuthGuard;
